module.exports = __webpack_public_path__ + "img/history-select.4e3992cb.png";